import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgAutoSunMoonGhost = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M11.642 7.441a1 1 0 0 0-1.229-1.229 6 6 0 1 0 7.375 7.375 1 1 0 0 0-1.229-1.228 4.006 4.006 0 0 1-4.917-4.918'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='m18.794 9.756-.358-1.003h-2.872l-.358 1.003a.75.75 0 0 1-1.412-.505l2.029-5.681c.395-1.107 1.96-1.107 2.354 0l2.03 5.681a.75.75 0 0 1-1.413.505M16.1 7.253l.9-2.52.9 2.52z'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M11.642 7.444a1 1 0 0 0-1.229-1.228 6 6 0 1 0 7.375 7.375 1 1 0 0 0-1.229-1.229 4.006 4.006 0 0 1-4.917-4.918M8 12.004c0-1.268.59-2.4 1.511-3.132a6 6 0 0 0 5.62 5.62A4 4 0 0 1 8 12.003'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      d='M12 19.503a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1M5.99 19.428l.707-.707a1 1 0 1 0-1.415-1.414l-.707.707a1 1 0 1 0 1.414 1.414M4.5 12.003a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1M17.303 18.72l.707.708a1 1 0 0 0 1.415-1.414l-.707-.707a1 1 0 0 0-1.415 1.414M5.283 6.7a1 1 0 1 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.415 1.414z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgAutoSunMoonGhost)
export default ForwardRef
